import { styled } from 'styled-components'

import Container from '../../Container/Container'

export const StyledContainer = styled(Container)`
  padding: 1.5rem 0 0;
  margin-top: 2rem;
  background: white;
`
